export default __webpack_public_path__ + "static/media/silver.d95bc4a7.png";